
import AngledButton from "../AngledButton"
import "./MessageInput.css"

export default function MessageInput({
    title,
    onChangeMessage,
    onClickSend,
    disabled
}) {
    return (
        <div id="message-input-wrapper">
            <span id="message-input-title">{title}</span>
            <textarea
                className="message-input"
                onChange={onChangeMessage}
                placeholder="Deja tu mensaje"
            />
            <div className="buttons-container">
                <AngledButton
                    title="Enviar"
                    onClick={onClickSend}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}